import { AppIcon, InfoModal } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Button, Typography, SxProps, Theme } from '@mui/material';

const STRINGS = appStrings.modules.results.startOverModal;

type StartOverConfirmationModalProps = Readonly<{
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}>;

export function StartOverConfirmationModal({
  open,
  onClose,
  onConfirm,
}: StartOverConfirmationModalProps) {
  return (
    <InfoModal
      open={open}
      onClose={onClose}
      width="sm"
      icon="RefreshCcw01"
      headerContent={<Typography variant="text-lg-semibold">{STRINGS.title}</Typography>}
      bodyContent={
        <Box sx={bodySx}>
          <Typography variant="text-sm-regular" sx={descriptionSx}>
            {STRINGS.description}
          </Typography>
          <Box sx={actionsSx}>
            <Button
              id="start-over-cancel-btn"
              hierarchy="Secondary gray"
              size="lg"
              onClick={onClose}
            >
              {STRINGS.cancel}
            </Button>
            <Button
              id="start-over-confirm-btn"
              hierarchy="Primary"
              size="lg"
              onClick={onConfirm}
              icon="Leading"
              startIcon={
                <Box sx={{ display: 'flex', transform: 'scaleX(-1)' }}>
                  <AppIcon iconName="RefreshCcw01" diameter="20px" color="Colors/Base/White" />
                </Box>
              }
            >
              {STRINGS.confirm}
            </Button>
          </Box>
        </Box>
      }
    />
  );
}

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-3xl'],
});

const descriptionSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});

const actionsSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: backrs.spacing['spacing-lg'],
});
